import { type ReactNode } from 'react';
import { madridToday } from '@/utils/madrid-date';
import {
  getVacationDates,
  isOnVacation,
  formatVacationRange,
} from '@/utils/vacation';
import type { Approacher } from '../types';

export { Actions, type ActionProps } from './vacation-bar-actions';

const INPUT =
  'rounded-md border border-white/[0.06] bg-surface-elevated px-sm py-xs text-xs text-text-primary focus:outline-none focus:ring-1 focus:ring-info/40';

export function ActiveStatus({ a }: { a: Approacher }): ReactNode {
  const range = getVacationDates(a);
  if (!range.from || !range.to) return null;
  const active = isOnVacation(a, madridToday());
  const label = active ? 'De vacaciones' : 'Vacaciones programadas';
  return (
    <p className="text-xs text-text-secondary">
      {label}: {formatVacationRange(range.from, range.to)}
    </p>
  );
}

function DateField({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}): ReactNode {
  return (
    <input
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={INPUT}
    />
  );
}

export function DateInputs({
  from,
  to,
  onFrom,
  onTo,
}: {
  from: string;
  to: string;
  onFrom: (v: string) => void;
  onTo: (v: string) => void;
}): ReactNode {
  return (
    <div className="flex items-center gap-sm">
      <DateField value={from} onChange={onFrom} />
      <span className="text-xs text-text-tertiary">→</span>
      <DateField value={to} onChange={onTo} />
    </div>
  );
}
